import { useState, useEffect } from 'react';

const emptyNarratives = {
  hypotheses: [],
  insights: [],
  analyses: [],
};

const useConnectedNarratives = (parentContentId, narratives, search) => {
  const [availableToConnectNarratives, setAvailableToConnectNarratives] =
    useState(emptyNarratives);
  const [
    filteredAvailableToConnectNarratives,
    setFilteredAvailableToConnectNarratives,
  ] = useState(emptyNarratives);
  const [previouslyConnectedNarratives, setPreviouslyConnectedNarratives] =
    useState(emptyNarratives);

  useEffect(() => {
    const testString = (testSearch, string) =>
      (string || '').toLowerCase().includes(testSearch.toLowerCase());

    if (!narratives || !Object.keys(narratives).length) {
      setAvailableToConnectNarratives(emptyNarratives);
      setPreviouslyConnectedNarratives(emptyNarratives);
      return;
    }

    const filterByIsConnectedToParent = (narrative) => {
      return narrative.links.some(
        (link) => link.id === parseInt(parentContentId, 10) && link.linkId
      );
    };

    const filterByIsNotConnectedToParent = (narrative) =>
      !filterByIsConnectedToParent(narrative);

    const filterBySearch = (narrative) => {
      return (
        (testString(search, narrative.title) ||
          testString(search, narrative.body) ||
          testString(search, narrative.conclusion)) &&
        filterByIsNotConnectedToParent(narrative)
      );
    };

    setPreviouslyConnectedNarratives({
      hypotheses:
        narratives.hypotheses &&
        narratives.hypotheses.filter(filterByIsConnectedToParent),
      insights:
        narratives.insights &&
        narratives.insights.filter(filterByIsConnectedToParent),
      analyses:
        narratives.analyses &&
        narratives.analyses.filter(filterByIsConnectedToParent),
    });

    const available = {
      hypotheses:
        narratives.hypotheses &&
        narratives.hypotheses.filter(filterByIsNotConnectedToParent),
      insights:
        narratives.insights &&
        narratives.insights.filter(filterByIsNotConnectedToParent),
      analyses:
        narratives.analyses &&
        narratives.analyses.filter(filterByIsNotConnectedToParent),
    };
    setAvailableToConnectNarratives(available);

    if (search) {
      setFilteredAvailableToConnectNarratives({
        hypotheses:
          narratives.hypotheses && narratives.hypotheses.filter(filterBySearch),
        insights:
          narratives.insights && narratives.insights.filter(filterBySearch),
        analyses:
          narratives.analyses && narratives.analyses.filter(filterBySearch),
      });
    } else {
      setFilteredAvailableToConnectNarratives(available);
    }
  }, [narratives, search, parentContentId]);

  return {
    availableToConnectNarratives,
    filteredAvailableToConnectNarratives,
    previouslyConnectedNarratives,
  };
};

export default useConnectedNarratives;
